import './cart.css';

import { Script } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';

import ColorContext from '../../context/ColorContext';
import LanguageContext from '../../context/LanguageContext';
import { tw } from '../../utils/tailwind';
import { Flex } from '../Core';
import CartIcon from '../SVG/CartIcon';
import Text from '../Text';

type Cart = { total: number; items: [] };

declare let window: {
  Snipcart: {
    api: { session: { setLanguage: (slug: string) => void } };
    store: {
      getState: () => { cart: Cart };
      subscribe: (callback: () => void) => void;
    };
  };
};

const Cart: FCWithClassName = (props) => {
  const [cartTotal, setCartTotal] = useState(0);
  const [isSnipcartLoaded, setIsSnipcartLoaded] = useState(false);
  const {
    currentLanguage: { slug },
  } = useContext(LanguageContext);
  const { theme } = useContext(ColorContext);
  useEffect(() => {
    const Snip = window.Snipcart;
    // on first load, Snipcart CDN script might not be loaded yet because of <Script /> waiting for end of hydration
    if (!Snip) return;
    Snip.api.session.setLanguage(slug);
    const initialState = Snip.store.getState() ?? {
      cart: { items: [], total: 0 },
    };
    setCartTotal(initialState.cart.total);

    const unsubscribe = Snip.store.subscribe(() => {
      const newState = Snip.store.getState();
      setCartTotal(newState.cart.total);
    });

    return unsubscribe;
  }, [isSnipcartLoaded]);

  return (
    <Flex
      align="center"
      className={tw(
        'pb-1 cursor-pointer snipcart-checkout text-text',
        props.className
      )}
      aria-label="Shopping cart"
    >
      <Script
        src="https://cdn.snipcart.com/themes/v3.3.0/default/snipcart.js"
        onLoad={() => setIsSnipcartLoaded(true)}
      />
      <CartIcon
        className={
          theme === 'institute' ? 'text-text lg:text-white' : 'text-text'
        }
      />
      <Text
        className={tw(
          theme === 'institute' ? 'text-text lg:text-white' : 'text-text',
          'pt-2'
        )}
      >
        {`${cartTotal.toString()}€`}
      </Text>
    </Flex>
  );
};

export default Cart;
